<div class="checkbox-group">
  <div>
    <span class="topics-section-title">Select to subscribe to insights *</span>

    <div class="topics-list">
      <div class="topic">
        <input
          type="checkbox"
          name="boardGovernance"
          [(ngModel)]="topics!.boardGovernance"
          (change)="changed()"
          id="topicBoardGovernance"
          aria-describedby="topicBoardGovernance"
        />
        <label for="topicBoardGovernance" id="topicBoardGovernance">
          Board Governance Quarterly (boards)
        </label>
      </div>
      <div class="topic">
        <input
          type="checkbox"
          name="tmts"
          [(ngModel)]="topics!.tmts"
          (change)="changed()"
          id="topicTmts"
          aria-describedby="topicTmts"
        />
        <label for="topicTmts" id="topicTmts">
          Global Connections (technology, media, telecommunications)
        </label>
      </div>
      <div class="topic">
        <input
          type="checkbox"
          name="hrQuarterly"
          [(ngModel)]="topics!.hr"
          (change)="changed()"
          id="topicHrQuarterly"
          aria-describedby="topicHrQuarterly"
        />
        <label for="topicHrQuarterly" id="topicHrQuarterly">
          HR Quarterly (human resources)
        </label>
      </div>
      <div class="topic">
        <input
          type="checkbox"
          name="leadershipTrends"
          [(ngModel)]="topics!.leadershipTrends"
          (change)="changed()"
          id="topicLeadershipTrends"
          aria-describedby="topicLeadershipTrends"
        />
        <label for="topicLeadershipTrends" id="topicLeadershipTrendsLabel">
          Point of View / Top 10 Reads (general leadership)
        </label>
      </div>
    </div>
  </div>
</div>
